import React, { useState } from 'react';
import { FormControlLabel, Switch } from '@mui/material';

type Props = {
    onToggle: any
}

const ContralateralSwitch = ({ onToggle } : Props) => {
    const [checked, setChecked] = useState(false);

    const handleChange = () => {
        const newChecked = !checked;
        setChecked(newChecked);
        onToggle(newChecked);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <FormControlLabel
                control={
                    <Switch
                        checked={checked}
                        onChange={handleChange}
                        color="primary"
                    />
                }
                label="Contralateral"
            />
        </div>
    );
};

export default ContralateralSwitch;
